import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'

const dispatched = (name: 'fetchProductLTV' | 'purchaseProduct') =>
  ({ type: 'dispatchedHook', callbackConfig: { name, inputs: [], outputs: [] } }) as const

const pet_health_v2_purchase = (params: StepConfigParams) =>
  ({
    stepContent: [{ type: 'spinner' }],
    isAutoSubmitStep: true,
    onPrepare: dispatched('fetchProductLTV'),
    onSubmit: dispatched('purchaseProduct'),
    subFlow: params.subFlow,
  }) as const satisfies AnyStepConfiguration

export default pet_health_v2_purchase
